import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-filter-list-dialog-button',
  templateUrl: './filter-list-dialog-button.component.html',
  styleUrls: ['./filter-list-dialog-button.component.scss']
})
export class FilterListDialogButtonComponent {
  @Input() count: number = 0;
}
